export const objectsSelector = (state) => state.app.objects;

const ObjectsSelector = {
  objects: objectsSelector,
};

export default ObjectsSelector;
